import { useAddChat } from '@/hooks/useWorkspace';
import { api } from '@/lib/trpc/react';

export const useCreateChat = () => {
  const { addChat } = useAddChat();

  const { mutateAsync: createChat } = api.chat.create.useMutation({
    onSuccess: (data) => {
      addChat(data);
    },
  });

  return { createChat };
};
